export const MIGRATION_VARIANT = {
  ONBOARDING: 'onboarding',
  LIVE: 'live',
};

/*
 * Migration window logic (CPMT-5371): "onboarding" while the retailer is being
 * set up in Admin (Hub still system of record), "live" once Admin is the system
 * of record. Null means no migration state — legacy retailers and environments
 * where hub-backend does not send migration data yet.
 */
export default migration => {
  if (!migration || !migration.has_started_migration) return null;

  return migration.is_admin_managed
    ? MIGRATION_VARIANT.LIVE
    : MIGRATION_VARIANT.ONBOARDING;
};
